import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {AuthConfig, OAuthService} from 'angular-oauth2-oidc';
import {DMSConfigService} from './dmsconfig.service';
import {HandleErrorService} from './handle-error.service';

@Injectable()
export class LoginService {
  authConfig: AuthConfig;
  userNavigatedUrl = '/dms';
  private hasNavigated = false;

  constructor(
    private readonly oauthService: OAuthService,
    private readonly router: Router,
    private readonly dmsConfigService: DMSConfigService,
    private readonly handleErrorService: HandleErrorService
  ) {
    const config = this.dmsConfigService.getConfig();
    this.authConfig = {
      clientId: config.CLIENT_ID,
      issuer: config.ISSUER,
      scope: config.SCOPE,
      responseType: 'code',
      redirectUri: config.REDIRECT_URI,
      logoutUrl: config.LOGOUT_URL,
    };
  }

  isSessionValid() {
    return (
      this.oauthService.getAccessToken() != null &&
      this.oauthService.hasValidAccessToken()
    );
  }

  setNavigatedUrl(url: string) {
    this.userNavigatedUrl = url;
  }

  login() {
    this.handleErrorService.errorMessage = '';
    if (this.isSessionValid()) {
      this.router.navigate([this.userNavigatedUrl]);
      return;
    }
    this.oauthService.configure(this.authConfig);
    this.oauthService.loadDiscoveryDocument().then(
      () => {
        this.oauthService.tryLoginCodeFlow().then(() => {
          if (!this.oauthService.hasValidAccessToken()) {
            this.oauthService.initLoginFlow();
          } else {
            if (!this.hasNavigated) {
              this.hasNavigated = true;
              this.router.navigate([this.userNavigatedUrl]);
            }
          }
        });
      },
      (reason) =>
        console.error(
          'Could not load authentication document',
          'Warning',
          reason
        )
    );
  }

}
